import moment from "moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
const useFigures = () => {
  const { id } = useParams();
  const [today, setToday] = useState(moment().format("DD/MM/YYYY"));
  const allSales = useSelector((state) => state.sales.Sales);
  const { mode } = useSelector((state) => state.store.Store);
  const salesHistory =
    mode !== "Admin"
      ? allSales.filter((sale) => sale.mode === mode)
      : [...allSales];
  const sales = salesHistory?.filter((sale) => sale.item_id === id);
  const salesToday = !id
    ? salesHistory?.filter((sale) => sale.createdAt?.endsWith(today))
    : sales.filter((sale) => sale.createdAt?.endsWith(today));

  const dailySales = salesToday?.reduce((a, b) => a + b.cost, 0);
  const dailyData = {
    cash: salesToday
      ?.filter(
        (sale) =>
          sale.payment_method === "Cash" || sale.payment_method === undefined,
      )
      .reduce((a, b) => a + b.cost, 0),
    momo: salesToday
      ?.filter((sale) => sale.payment_method === "Mobile Money")
      .reduce((a, b) => a + b.cost, 0),
    bank: salesToday
      ?.filter((sale) => sale.payment_method === "Bank Transfer")
      .reduce((a, b) => a + b.cost, 0),
    credit: salesToday
      ?.filter((sale) => sale.payment_method === "Credit")
      .reduce((a, b) => a + b.cost, 0),
  };
  const profitToday = salesToday?.reduce((a, b) => a + b?.profit, 0);

  const MonthlySalesRecords = !id
    ? salesHistory?.filter((sale) =>
        sale?.createdAt?.endsWith(moment().format("/MM/YYYY")),
      )
    : salesHistory?.filter(
        (sale) =>
          sale.item_id === id &&
          sale?.createdAt?.endsWith(moment().format("/MM/YYYY")),
      );
  const monthlySalesFigure = MonthlySalesRecords.reduce(
    (a, b) => a + b.cost,
    0,
  );
  // come and delete later
  const wholesale_sales = salesHistory?.filter(
    (sale) => sale.sale_type === "wholesale",
  );
  const retail_sales = salesHistory?.filter(
    (sale) => sale.sale_type === "retail",
  );

  const salesData = {
    retail: salesHistory
      ?.filter(
        (sale) => sale.sale_type === "retail" || sale.sale_type === undefined,
      )
      .reduce((a, b) => a + b.cost, 0),

    retail_profit: salesHistory
      ?.filter(
        (sale) => sale.sale_type === "retail" || sale.sale_type === undefined,
      )
      .reduce((a, b) => a + b?.profit || 0, 0),

    wholesale: salesHistory
      ?.filter((sale) => sale.sale_type === "wholesale")
      .reduce((a, b) => a + b.cost, 0),

    wholesale_profit: salesHistory
      ?.filter((sale) => sale.sale_type === "wholesale")
      .reduce((a, b) => a + b?.profit || 0, 0),

    agreed: salesHistory
      ?.filter((sale) => sale.sale_type === "agreed price")
      .reduce((a, b) => a + b?.cost, 0),

    agreed_profit: salesHistory
      ?.filter((sale) => sale.sale_type === "agreed price")
      .reduce((a, b) => a + b.profit, 0),
  };
  const monthlyProfit = MonthlySalesRecords.reduce(
    (a, b) => a + (b.profit ?? 0),
    0,
  );
  // ANNUAL SALES
  const AnnualSalesRecord = !id
    ? salesHistory?.filter(
        (sale) => sale?.createdAt?.indexOf(moment().format("/YYYY")) > -1,
      )
    : salesHistory?.filter(
        (sale) =>
          sale.item_id === id &&
          sale?.createdAt?.indexOf(moment().format("/YYYY")) > -1,
      );
  const annualSalesFigure = AnnualSalesRecord.reduce((a, b) => a + b.cost, 0);
  const annualProfit = AnnualSalesRecord.reduce(
    (a, b) => a + (b?.profit ?? 0),
    0,
  );
  const totalSalesFigure = !id
    ? salesHistory?.reduce((a, b) => a + b.cost, 0)
    : allSales
        ?.filter((item) => item.item_id === id)
        ?.reduce((a, b) => a + b.cost, 0);
  const totalProfit = !id
    ? allSales?.reduce((a, b) => a + (b?.profit ?? 0), 0)
    : allSales
        ?.filter((item) => item.item_id === id)
        ?.reduce((a, b) => a + (b.profit ?? 0), 0);
  return {
    dailySales,
    monthlySalesFigure,
    annualSalesFigure,
    totalSalesFigure,
    profitToday,
    monthlyProfit,
    annualProfit,
    totalProfit,
    dailyData,
    salesData,
    salesHistory,
    wholesale_sales,
    retail_sales,
    setToday,
    today,
  };
};
export default useFigures;
